import { useEffect, useState } from "react";
import axios from "axios";
import { Phone, CalendarCheck, Menu } from "lucide-react";
import MenuDrawer from "./MenuDrawer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Nav({ onBook }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    axios.get(`${API}/next-slot`).then((r) => setSlot(r.data.slot)).catch(() => {});
  }, []);

  return (
    <>
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b-[3px] border-tpeco-ink" data-testid="main-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between gap-3 h-16 sm:h-20">
          <a href="/" className="flex items-center gap-3 shrink-0" data-testid="nav-logo-link">
            <img src="/logo.webp" alt="The Plumbing & Electrical Co." className="h-11 w-11 sm:h-14 sm:w-14 object-contain" data-testid="nav-logo-img" />
            <span className="font-display text-tpeco-ink text-lg sm:text-2xl tracking-wide leading-none uppercase">
              HOT WATER SYSTEMS <span className="text-tpeco-blue">PERTH</span>
            </span>
          </a>
          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="tel:0475776555"
              data-testid="nav-call-button"
              className="hidden sm:inline-flex btn-brutal-dark !px-5 !py-2 !text-lg"
            >
              <Phone className="w-4 h-4" strokeWidth={2.5} /> 0475 776 555
            </a>
            <button
              onClick={onBook}
              data-testid="nav-book-button"
              className="hidden sm:inline-flex btn-brutal !px-4 sm:!px-5 !py-1.5 !text-lg items-center pulse-breathe"
            >
              <CalendarCheck className="w-5 h-5 shrink-0" strokeWidth={2.5} />
              {slot ? (
                <span className="flex flex-col items-start leading-none text-left ml-1">
                  <span className="text-[0.55rem] tracking-[0.2em]" data-testid="nav-next-slot-label">NEXT SLOT — BOOK IT</span>
                  <span className="text-xl tracking-wide" data-testid="nav-next-slot-time">{slot}</span>
                </span>
              ) : (
                <span className="ml-1">BOOK ONLINE</span>
              )}
            </button>
            <button
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
              data-testid="nav-burger-button"
              className="w-11 h-11 sm:w-12 sm:h-12 rounded-full border-[3px] border-tpeco-ink bg-white flex items-center justify-center shadow-[0_4px_0_0_#0A0A0A] hover:translate-y-[2px] hover:shadow-[0_2px_0_0_#0A0A0A] transition-[transform,box-shadow] duration-150"
            >
              <Menu className="w-5 h-5" strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </header>
      <MenuDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
